import { render } from "./TelaCkEditor.vue?vue&type=template&id=467c8e47&ts=true"
import script from "./TelaCkEditor.vue?vue&type=script&lang=ts"
export * from "./TelaCkEditor.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__